export default [
  {
    id: 105,
    jobTitle: "Direct Facilitator",
    companyName: "Inc",
    department: "Tools",
    location: "East Chadburgh",
    phone: "60060",
    requiredExp: "4-7",
    type: "internship",
    candidates: 10,
    salary: "85-99",
    status: "rejected",
  },
  {
    id: 110,
    jobTitle: "Paradigm Agent",
    companyName: "Inc",
    department: "Baby",
    location: "North Wilfrid",
    phone: "38990",
    requiredExp: "25-38",
    type: "consultant",
    candidates: 7,
    salary: "15-24",
    status: null,
  },
  {
    id: 115,
    jobTitle: "Markets Associate",
    companyName: "Inc",
    department: "Tools",
    location: "Adrienborough",
    phone: "42411",
    requiredExp: "4-7",
    type: "Full time",
    candidates: 10,
    salary: "25-38",
    status: "accepted",
  },
  {
    id: 120,
    jobTitle: "Director",
    companyName: "and Sons",
    department: "Automotive",
    location: "Natfort",
    phone: "32393-3089",
    requiredExp: "25-38",
    type: "consultant",
    candidates: 10,
    salary: "25-38",
    status: "rejected",
  },
  {
    id: 125,
    jobTitle: "Internal Facilitator",
    companyName: "Inc",
    department: "Jewelery",
    location: "Kiehnport",
    phone: "71458-5793",
    requiredExp: "45-40",
    type: "Full time",
    candidates: 29,
    salary: "11-13",
    status: "rejected",
  },
  {
    id: 130,
    jobTitle: "IA Assistant",
    companyName: "Inc",
    department: "Computers",
    location: "South Milfordburgh",
    phone: "97392-1632",
    requiredExp: "85-99",
    type: "internship",
    candidates: 8,
    salary: "25-38",
    status: "accepted",
  },
  {
    id: 135,
    jobTitle: "Applications Liaison",
    companyName: "and Sons",
    department: "Automotive",
    location: "West Keithburgh",
    phone: "84992",
    requiredExp: "85-99",
    type: "internship",
    candidates: 15,
    salary: "25-38",
    status: null,
  },
  {
    id: 140,
    jobTitle: "Implementation Consultant",
    companyName: "Inc",
    department: "Beauty",
    location: "Gregoriaview",
    phone: "80355-7777",
    requiredExp: "11-13",
    type: "internship",
    candidates: 14,
    salary: "11-13",
    status: "rejected",
  },
  {
    id: 145,
    jobTitle: "Web Designer",
    companyName: "and Sons",
    department: "Movies",
    location: "Izabellaland",
    phone: "92377-1778",
    requiredExp: "11-13",
    type: "internship",
    candidates: 5,
    salary: "11-13",
    status: "rejected",
  },
  {
    id: 150,
    jobTitle: "Division Representative",
    companyName: "LLC",
    department: "Health",
    location: "Fionaville",
    phone: "03079",
    requiredExp: "4-7",
    type: "internship",
    candidates: 16,
    salary: "85-99",
    status: null,
  },
  {
    id: 155,
    jobTitle: "Marketing Agent",
    companyName: "LLC",
    department: "Home",
    location: "Angiestad",
    phone: "03241-1814",
    requiredExp: "85-99",
    type: "internship",
    candidates: 5,
    salary: "11-13",
    status: "rejected",
  },
  {
    id: 160,
    jobTitle: "Marketing Architect",
    companyName: "Inc",
    department: "Electronics",
    location: "East Alexandroport",
    phone: "81264",
    requiredExp: "7-10",
    type: "on-contract",
    candidates: 5,
    salary: "25-38",
    status: null,
  },
  {
    id: 165,
    jobTitle: "Product Engineer",
    companyName: "and Sons",
    department: "Shoes",
    location: "Caylafurt",
    phone: "59461",
    requiredExp: "45-40",
    type: "internship",
    candidates: 6,
    salary: "4-7",
    status: "accepted",
  },
  {
    id: 170,
    jobTitle: "Program Consultant",
    companyName: "LLC",
    department: "Home",
    location: "Mantebury",
    phone: "88101",
    requiredExp: "7-10",
    type: "Full time",
    candidates: 6,
    salary: "85-99",
    status: "accepted",
  },
  {
    id: 175,
    jobTitle: "Operations Analyst",
    companyName: "Group",
    department: "Shoes",
    location: "West Orrinfurt",
    phone: "93083-0224",
    requiredExp: "4-7",
    type: "Full time",
    candidates: 21,
    salary: "85-99",
    status: "rejected",
  },
  {
    id: 180,
    jobTitle: "Regional Technician",
    companyName: "Group",
    department: "Computers",
    location: "South Mitchelmouth",
    phone: "64997-5741",
    requiredExp: "85-99",
    type: "Full time",
    candidates: 13,
    salary: "85-99",
    status: "rejected",
  },
  {
    id: 185,
    jobTitle: "Metrics Engineer",
    companyName: "and Sons",
    department: "Tools",
    location: "South Charlotte",
    phone: "19601",
    requiredExp: "4-7",
    type: "internship",
    candidates: 30,
    salary: "11-13",
    status: "accepted",
  },
  {
    id: 190,
    jobTitle: "Lead Strategist",
    companyName: "Group",
    department: "Outdoors",
    location: "Vilmamouth",
    phone: "07913",
    requiredExp: "11-13",
    type: "on-contract",
    candidates: 5,
    salary: "25-38",
    status: null,
  },
  {
    id: 195,
    jobTitle: "Lead  Producer",
    companyName: "LLC",
    department: "Outdoors",
    location: "Spinkaview",
    phone: "17101-4987",
    requiredExp: "25-38",
    type: "Full time",
    candidates: 14,
    salary: "25-38",
    status: null,
  },
];

